import React from 'react';
import Plot from 'react-plotly.js';

const cardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  border: '1px solid #e8f4f8',
  padding: '16px',
  transition: 'box-shadow 0.2s ease',
};

const titleStyle = {
  color: '#2c3e50',
  fontSize: '1.5rem',
  fontWeight: 600,
  margin: '0 0 16px 0',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  borderBottom: '3px solid #75cae3',
  paddingBottom: '10px',
};

const plotConfig = {
  displaylogo: false,
  responsive: true,
  displayModeBar: false,
};

const GraphComp = (props) => {
  const { layout, data, filterKey, onSelectGroup, title, isFetching = false, renderLoading } = props;
  return (
  <div style={cardStyle}>
    <p style={titleStyle}>{title}</p>
    { isFetching && ( renderLoading && renderLoading() ) }
    { isFetching === false &&
      <Plot
          data={data}
          layout={layout}
          config={plotConfig}
          onClick={(event) => {
            if (onSelectGroup && data && data.length > 0) {
              const eventMember = (data[0].type === "pie") ? 'label' : 'x';
              const value = event.points[0][eventMember];
              const filter = {
                  [filterKey]: value,
              };
              onSelectGroup(filter);
            }
          }}
          style={{ cursor: onSelectGroup ? 'pointer' : 'default' }}
      />
    }
  </div>
  );
};

export default GraphComp;
